import {Injectable} from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpContextToken
} from '@angular/common/http';
import {Observable, throwError, BehaviorSubject} from 'rxjs';
import {catchError, filter, switchMap, take} from 'rxjs/operators';
import {Router} from '@angular/router'; // Import Router
import {AuthService} from "../service/auth.service";
import {DtoLoginResponse} from "../interfaces/core.types";
import {AppMessageService} from "../service/app-message.service";
import {environment} from "../../../environments/environment";

export const IG_Token = new HttpContextToken<boolean>(() => false);

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private authService: AuthService, private router: Router, private messageService: AppMessageService) {
  } // Inject Router

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq = request;
    const authToken = this.authService.getToken();
    const igToken = localStorage.getItem('igToken');

    if ((authToken
      && !request.url.endsWith("/api/auth/login")
      && !request.url.endsWith("/api/auth/loginPassCode")
      && !request.url.endsWith("/api/auth/otpLoginInitiate")
      && !request.url.endsWith("/api/auth/otpLoginVerify")
      && !request.url.includes("/mvseureg/")) || igToken) {
      authReq = this.addTokenHeader(request, authToken, igToken);
    } else {
      authReq = this.addTenantHeader(request);
    }

    return next.handle(authReq).pipe(catchError(error => {

      if (error instanceof HttpErrorResponse && error.url != null && error.url.includes("/mvseu/api/auth/")) {
        // errors within the AUTH components need to be returned directly without processing
        return throwError(error);
      } else {
        if (error instanceof HttpErrorResponse && error.status === 400) {
          // check whether TOKEN expired during DEBUG mode
          if (error.error && "data" in error.error && typeof error.error.data === 'string') {
            if (error.error.data.startsWith("The Token has expired")) {
              return this.handle401Error(authReq, next);
            }
          }
        } else if (error instanceof HttpErrorResponse && error.status === 401) {
          return this.handle401Error(authReq, next);
        } else if (error instanceof HttpErrorResponse && error.status === 406) {
          return this.handle406Error(authReq, next);
        }
      }

      return throwError(error);
    }));
  }

  private addTenantHeader(request: HttpRequest<any>) {

    if (!environment.tenant) {
      return request;
    }

    return request.clone({
      setHeaders: {
        "x-alpha-tenant": environment.tenant
      }
    });
  }

  private addTokenHeader(request: HttpRequest<any>, token: DtoLoginResponse | null, igToken: string | null) {
    let headers: { [name: string]: string } = {};

    if (token) {
      headers["ExAuthorization"] = `${token?.tokenType}${token?.accessToken}`
    } else if (igToken) {
      headers["IgAuthorization"] = `Bearer ig ${igToken}`;
    }
    // if(igToken){
    //   headers["IgAuthorization"] =  `Bearer ig_pass ${igToken}`;
    // }

    if (environment.tenant) {
      headers["x-alpha-tenant"] = environment.tenant;
    }

    return request.clone({
      setHeaders: headers
    });
  }

  private handle406Error(request: HttpRequest<any>, next: HttpHandler) {
    this.authService.logout(); // Ensure this method clears the tokens and user session
    this.router.navigate(['/']); // Redirect to login or root
    this.messageService.showErrorMessage("", "Bitte melde dich erneut an");
    return throwError(() => new Error('Bitte melde dich erneut an'));
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {

    this.authService.logout(); // Ensure this method clears the tokens and user session
    this.router.navigate(['/']); // Redirect to login or root
    this.messageService.showErrorMessage("", "Bitte melde dich erneut an");
    return throwError(() => new Error('Bitte melde dich erneut an'));

  }
}
